"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EncabezadoDeCatas() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section id="encabezado-de-catas" className="section relative min-h-[75vh] flex items-center justify-center overflow-hidden">
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/haya_tasting_experience_hero.png" alt="Spanish Olive Oil Tasting Experience" className="hero-img absolute inset-0 h-full w-full object-cover !text-[hsl(48,100%,96%)]" />
      <div className="absolute inset-0 bg-black/35" />
      
      <div ref={heroRef} className={`relative z-10 max-w-4xl mx-auto px-4 sm:px-8 py-24 text-center transition-all duration-800 ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 className="font-serif text-4xl font-semibold mb-8 leading-[1.2] tracking-tight !text-[hsl(48,100%,96%)] sm:text-5xl lg:text-[4rem]">
          Catas de Aceite de Oliva en La Haya
        </h1>
        
        <p className="text-lg sm:text-xl text-secondary/90 mb-8 max-w-2xl mx-auto leading-relaxed font-light">
          Descubre el auténtico sabor del aceite de oliva virgen extra en una experiencia sensorial única. En el Centro Español de La Haya aprenderás a reconocer aromas, sabores y matices mientras disfrutas de tapas y bebidas en un ambiente español.
        </p>

        <span className="block text-sm uppercase tracking-[0.2em] text-secondary/70 mb-10 font-medium">
          Plazas limitadas – máximo 10 personas por cata.
        </span>

        <Link to="#formulario-reserva">
          <Button size="lg" className="bg-primary text-secondary hover:bg-primary-hover border-none shadow-none rounded-lg px-10 py-4 h-auto font-medium text-base transition-colors duration-300">
            Reservar Mi Plaza
          </Button>
        </Link>
      </div>
    </section>;
}